module.exports = __webpack_public_path__ + "img/stepThree.13f2c06e.jpg";